import { Breadcrumb, Button, PageHeader } from 'antd';
import { FC } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import OrdersTable from '../components/tables/orders-table';
import FollowermaServicesTable from '../components/tables/followerma-services-table';

const FollowermaServicesListRoute: FC = () => {
  const navigate = useNavigate()

  return (<>
    <PageHeader
        title="فالور ما"
      style={{ padding: " 16px 0" }}
      onBack={() => navigate(-1)}
      />
    <FollowermaServicesTable />
  </>);
}

export default FollowermaServicesListRoute;
